/* =================== HEADER FULL =================== */
jQuery(document).ready(function ($) {
  if (!isMobileX(1119)) {
    const header = $(".fdx-menu");
    if (header.length > 0) {
      function toggleHeaderFull() {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > 100) {
          header.addClass("fixed");
        } else {
          header.removeClass("fixed");
        }
      }

      toggleHeaderFull();
      $(window).on(
        "scroll",
        debounce(function () {
          toggleHeaderFull();
        }, 10)
      );
    }
  }
});
